import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ArchiveStatus } from 'App/BillingDashboard/filterOptions.enum';

interface ArchiveFilterStatus {
  archiveFilterStatus: ArchiveStatus;
}

interface SetArchiveFilterStatusPayload {
  archiveFilterStatus: ArchiveStatus;
}

export const initialState: ArchiveFilterStatus = {
  archiveFilterStatus: ArchiveStatus.active
};

const archiveFilterStatusSlice = createSlice({
  name: 'archiveFilterStatus',
  initialState,
  reducers: {
    setArchiveFilterStatus(state, action: PayloadAction<SetArchiveFilterStatusPayload>) {
      state.archiveFilterStatus = action.payload.archiveFilterStatus;
    }
  }
});

export const {
  setArchiveFilterStatus
} = archiveFilterStatusSlice.actions;

export default archiveFilterStatusSlice.reducer;
